import "./Cart.module.css";
import Intestazione from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import PieDiPagina from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <Intestazione />
      <CartContent />
      <PieDiPagina />
    </div>;
}